export enum RequestStatus {
  None = 'None',
  Inprogress = 'Inprogress',
  Error = 'Error',
  Completed = 'Completed'
}
